export function latestRiskChart(x, y, yName, id, maxY) {
    let Barchart = window["mbc-vertical-bar"];
    let container = d3.select(id);
    let chart = new Barchart({
            "xAxisOrient": "bottom",
            "tooltip": false,
            "hasBenchmarks": true,
            "showGrayBands": false,
            "dottedBenchmarks": false,
            "defaultBenchmarkStyle": false,
            "stacked": false,
            "y1AxisOrient": "left",
            "y1AxisTicksAlign": "left",
            "y1TickSymbol": "",
            // "customBarPadding": "50",
            "showZeroLine": true
        }),
        dataset = {
            "xDomain": x,
            "y1AxisData": [{
                "name": "风险等级R1",
                "values": y
            }]
        };

    let tempResult =  Math.ceil(maxY / 1000) * 1000;
    if(tempResult - maxY < 500)
    {
        maxY = (Math.ceil(maxY / 1000)+1) * 1000;
    }
    else
    {
        maxY = Math.ceil(maxY / 1000) * 1000;
    }    

    chart.__attributes.yDomain = [0, maxY]
    container.datum(dataset).call(chart.init());

    d3.select(id + " .mbc-axis-bottom").append("text").text("单位(只)").attr("x", "-58").attr("y", "15").attr("class", "tick_text");

    d3.select(id + " .mbc-canvas").attr("height", d3.select(id + " .mbc-canvas").attr("height") + 20);

    let color = ["#496BB3", "#F47521", "#A5A4A4", "#FEC20F", "#5C9BD3"];
    let i = 0;
    d3.selectAll(id + " .bar-group").each(function() {
        let rect = d3.select(this).select("rect");
        rect.attr("fill", color[i]);

        d3.select(this).append('text').text(y[i])
            .attr("y", parseFloat(rect.attr("y")) - 2)
            .attr("x", "77")
            .attr("style", "text-anchor: middle;");
        i++;
    });

    d3.select(id + " [role='legend']").attr("height", "118");
    d3.select(id + " .mbc-chart-legend-inner")[0][0].outerHTML = '<g class="legend-item" style="margin-right:20px;" transform="translate(0,2)"><text class="dataName0" x="15" y="10"><tspan x="15">R1</tspan></text><rect x="0" y="0" width="10" height="10" fill="#496BB3" fill-opacity="0.8"></rect></g>    <g class="legend-item"><text class="dataName1" x="15" y="32"><tspan x="15">R2</tspan></text><rect x="0" y="22" width="10" height="10" fill="#F47521" fill-opacity="0.8"></rect></g>    <g class="legend-item"><text class="dataName2" x="15" y="54"><tspan x="15">R3</tspan></text><rect x="0" y="44" width="10" height="10" fill="#A5A4A4" fill-opacity="0.8"></rect></g>    <g class="legend-item"><text class="dataName3" x="15" y="76"><tspan x="15">R4</tspan></text><rect x="0" y="66" width="10" height="10" fill="#FEC20F" fill-opacity="0.8"></rect></g>    <g class="legend-item"><text class="dataName4" x="15" y="98"><tspan x="15">R5</tspan></text><rect x="0" y="88" width="10" height="10" fill="#5C9BD3" fill-opacity="0.8"></rect></g>';

}

export function marketRiskPortraitChart(riskPortrait, id, minY, maxY) {
    var Core = window["mbc-core"],
        Barchart = window["mbc-vertical-bar"];
    let container = d3.select(id);

    var ExtendedVerticalBarChart = Barchart.extend({
        drawLegend: function() {

        }
    });

    let chart = new ExtendedVerticalBarChart({
            "xAxisOrient": "bottom",
            "tooltip": true,
            "hasBenchmarks": true,
            "showGrayBands": false,
            "dottedBenchmarks": false,
            "defaultBenchmarkStyle": true,
            "stacked": false,
            "y1AxisOrient": "left",
            "y1AxisTicksAlign": "left",
            "legend": true,
            "y1TickSymbol": "",
            "showGrayBands": true,
            // "customBarPadding": "50",
            "colors": ["#496BB3", "#F47521", "#A5A4A4", "#FEC20F", "#5C9BD3"],
            "ticksNumber": 8
        }),
        dataset = {
            "xDomain": riskPortrait.totalRisk,
            "y1AxisData": [{
                "name": "平均最大回撤",
                "values": riskPortrait.avgMaximumDrawdown
            }, {
                "name": "平均滚动收益6M",
                "values": riskPortrait.avgRollingReturnM6
            }, {
                "name": "平均滚动收益1Y",
                "values": riskPortrait.avgRollingReturnM12
            }, {
                "name": "平均滚动收益3Y",
                "values": riskPortrait.avgRollingReturnM36
            }]
        };

    var Utils = Core.Utils;
    minY = Math.ceil(minY / 5) * 5 - 15;
    maxY = Math.ceil(maxY / 5) * 5 + 15;
    chart.__attributes.yDomain = [minY, maxY];
    container.datum(dataset).call(chart.init());

    d3.select(id + " .mbc-axis-bottom").append("text").text("单位(%)").attr("x", "-50").attr("y", "18").attr("class", "tick_text");
    d3.select(id + " .mbc-chart-legend-inner").attr("transform", "translate(0,2)");

}


export function marketRiskPortraitChartForFundNew(self, riskPortrait, riskPortraitBenchMark, riskPortraitBenchMarkRisk, id, minY, maxY) {
    var Core = window["mbc-core"],
        Barchart = window["mbc-vertical-bar"];

    clearTimeout(self.fundRiskMarketTimeout);
    self.fundRiskMarketTimeout = setTimeout(() => {
        let container = d3.select(id);

        var ExtendedVerticalBarChart = Barchart.extend({
            drawLegend: function() {}
        });
    let tempTitle='R'+riskPortraitBenchMarkRisk+'基金';

    let newExtendedVerticalBarChart= ExtendedVerticalBarChart.extend({
        fixyDomain: function (array1, array2, ticksNumber) {
            //找到最大和最小值
            var min = 999, max = -999;
            for (var i = 0; i < array1.length;++i) {
                var vItem = array1[i].values[0].value;
                if (vItem < min) {
                    min = vItem;
                }

                if (vItem > max) {
                    max = vItem;
                }
            }
            for (var i = 0; i < array2[0].series.length;++i) {
                var vItem = array2[0].series[i];
                if (vItem < min) {
                    min = vItem;
                }

                if (vItem > max) {
                    max = vItem;
                }
            }

            ticksNumber = ticksNumber || 4;
            var revisedDomain = [];
            var distance = 0;

            if (min >= 0) {
                distance = max;
            } else if (max <= 0) {
                distance = -min;
            } else {
                distance = Math.abs(max - min);
            }

            var domainStep = distance / ticksNumber;
            
            var revisedMin = 0, revisedMax=0, revisedTicksNumber = 0;
            while (min < revisedMin) {
                revisedMin -= domainStep;
                ++revisedTicksNumber;
            }

            while (revisedMax < max) {
                revisedMax += domainStep;
                ++revisedTicksNumber;
            }
        
            revisedDomain.push(revisedMin);
            revisedDomain.push(revisedMax);
            revisedDomain.push(revisedTicksNumber);
        
            return revisedDomain;
        },
        /**
         * @override
         */
        beforeDraw: function () {

            this.redoCanvas();

            var dataManager = this.get("data");
            var canvas = this.get("canvas");
            var tickValues = this.get("tickValues");
            var y1LabelText = this.get("y1AxisLabel");
            var y2LabelText = this.get("y2AxisLabel");
            var yAxesLabelWidth = this.get("yAxesLabelWidth");
            var yDomain = this.get("yDomain");
            var domain;

            if (!y1LabelText && !y2LabelText) {
                canvas.set("yAxesLabelWidth", 0);
            } else {
                canvas.set("yAxesLabelWidth", yAxesLabelWidth);
            }

            canvas.set("tickSize", this.get("yTickSize"));
            canvas.set("axesSpacing", this.get("yAxesSpacing"));
            canvas.set("axesPadding", this.get("yPadding"));
            canvas.set("margin", this.getMargins());
            
            if (this.get("_yDomain") == null) {
                var revisedDomain = this.fixyDomain(this.get("data").get(this.get("y1DataSource")), 
                this.get("data").get(this.get("benchmarksDataSource")), this.get("ticksNumber"));
                yDomain[0] = revisedDomain[0];
                yDomain[1] = revisedDomain[1];
                this.set("ticksNumber", revisedDomain[2]);
            }
            

            if (!yDomain && (!tickValues || tickValues.length < 2)) {
                domain = dataManager.calculateDomain({
                    groups: [this.get("y1DataSource"), this.get("benchmarksDataSource")],
                    symmetrical: this.get("ticksSymmetrical"),
                    steps: this.get("ticksNumber"),
                    stacked: this.get("stacked")
                });
                this.set("_yDomain", domain);
            } else if (!yDomain) {
                this.set("_yDomain", [tickValues[0], tickValues[tickValues.length - 1]]);
            } else {
                this.set("_yDomain", yDomain);
            }

            if (this.get("y2")) {
                this.set("y2Domain", [0, 100]);
            } else {
                this.get("axes").remove("y2");
            }

            if (canvas.get("outerWidth") <= this.get("breakpoint")) {
                this.set("yPadding", this.get("yPaddingSmall"));
            } else {
                this.set("yPadding", this.get("yPaddingBig"));
            }

            this.set("x0Domain", this.getX0Domain());

            if (this.get("customBarPadding")) {
                var barPadding = this.get("customBarPadding");
                this.set("barGroupPadding", barPadding);
            }else{
                this.setBarGroupPadding();
            }
        },
         getTickValuesWithZeroTick : function (domain, ticksNumber) {
            ticksNumber = ticksNumber || 4;
            var min = domain[0];
            var max = domain[1];
            var tickValues = [];
            var distance = 0;

            if (min >= 0) {
                distance = max;
            } else if (max <= 0) {
                distance = -min;
            } else {
                distance = Math.abs(max - min);
            }

            var domainStep = distance / ticksNumber;
            
            max += 0.1;
            while (min < max) {
                if (Math.abs(min) < 0.000001) {
                    tickValues.push(0.00);
                } else  {
                    tickValues.push(min);
                }

                min += domainStep;
            }
        
            return tickValues;
        },
        /**
         * Configure all axes used in the chart.
         */
        buildAxes: function () {
            var _this = this;
            var scales = this.get("scales");
            var axes = this.get("axes");
            var calculatedTicks = this.getTickValuesWithZeroTick(this.get("_yDomain"),
                this.get("ticksNumber"));
               //calculatedTicks = [-45.0, -26,-7,0,11,35];
            var tickValues = this.get("tickValues") || calculatedTicks;
            var tickValues2, y2axis;

            var tickFormat = function (symbol, length, formatFn) {
                return function (d, i) {
                    var value = _this.tickFormat(formatFn)(d);
                    value = Utils.string.convertDashToEnDash(value);
                    return (symbol && i === length - 1) ? symbol + value : value;
                };
            };

            var xAxis = d3.svg.axis()
                .scale(scales.scale("x"))
                .orient(this.get("xAxisOrient"))
                .tickFormat(function (d) {
                    return Utils.string.unmask(d);
                });

            if(this.get('xAxisDateLabel')){
                xAxis = this.get('dateAxis').getAxis();
            }

            var yAxis = d3.svg.axis()
                .scale(scales.scale("y1"))
                .orient(this.get("y1AxisOrient"))
                .tickSize(this.get("yTickSize"))
                .tickValues(tickValues)
                .tickFormat(tickFormat(this.get("y1TickSymbol"),
                    tickValues.length, this.get("y1TickFormat")));

            yAxis.axisLabel = this.get("y1AxisLabel");
            axes.axis("x", xAxis);
            axes.axis("y1", yAxis);

            if (this.get("y2")) {
                tickValues2 = Utils.chart.getTickValues(this.get("y2Domain"));

                y2axis = d3.svg.axis()
                    .scale(scales.scale("y2"))
                    .orient(this.get("y2AxisOrient"))
                    .tickSize(this.get("yTickSize"))
                    .tickValues(tickValues2)
                    .tickFormat(tickFormat(this.get("y2TickSymbol"),
                        tickValues2.length, this.get("y2TickFormat")));

                axes.axis("y2", y2axis);
            }
        },
        drawGrid: function () {
            var scales = this.get("scales");
            var y1Scale = scales.scale("y1");
            var xScale = scales.scale("x");
            var y1Axis = this.get("axes").axis("y1");
            var canvas = this.get("canvas");
            var tickValues = y1Axis.tickValues();
            var backGroup = canvas.get("backGroup");
            var yValue = this.canvasHeight();
            var grid = backGroup.selectAll(".grid-line")
                .data(tickValues);
            var bottomLines;
            var hiddenBars = this.get("hideBars");
            var isSmallHeight = this.get("canvas").height() <= this.get("screenMinHeight");
            var padding = this.get("barGroupPadding");
    
            if (this.get("showGrayBands")) {
                this.drawGrayBands();
            }
    
            var extractor = function (d) {
                return y1Scale(d);
            };
            var showZeroLine = this.get("showZeroLine");
    
            grid.enter()
                .append("line")
                .attrs({
                    x1: 0 + padding,
                    x2: canvas.width() - padding,
                    y1: extractor,
                    y2: extractor,
                    class: function (d, i) {
                        var appendClass = "";
                        if (i === 0) {
                            appendClass = "first";
                        }
                        if (i === tickValues.length - 1) {
                            appendClass = "last";
                        }
                        return "grid-line "+appendClass;
                    },
    
                    opacity: function (d, i) {
                        if (isSmallHeight) {
                            // if container's height is small, only show last grid line
                            return i !== tickValues.length - 1 && !hiddenBars ? 0 : 1;
                        } else {
                            return ((!showZeroLine && d === 0) || i === 0) && !hiddenBars ? 0 : 1;
                        }
                    }
                })
                .attr("stroke", function(d) {
                    return Math.abs(d) < 0.000001 ? "black" : "gray";
                })
                .attr("stroke-dasharray", function(d) {
                    if (Math.abs(d) < 0.000001) {
                        return "6,3";
                    } 
                })
                .attr("stroke-width", function(d) {
                    return Math.abs(d) < 0.000001? "2px" : "0.5px";
                });
    
            grid
                .attrs({
                    x1: 0 + padding/2,
                    x2: canvas.width() - padding/2,
                    y1: extractor,
                    y2: extractor,
                    opacity: function (d, i) {
                        if (isSmallHeight) {
                            // if container's height is small, only show last grid line
                            return i !== tickValues.length - 1 && !hiddenBars ? 0 : 1;
                        } else {
                            return ((!showZeroLine && d === 0) || i === 0) && !hiddenBars ? 0 : 1;
                        }
                    }
                });
    
            grid.exit().remove();
    
            // Draw bottom lines
            if (y1Scale.domain()[0] < 0) {
                bottomLines = backGroup.selectAll(".bottom-line").data(xScale.domain());
                var linesGap = this.get("showGrayBands") ? 0 : this.get("barGroupPadding");
                bottomLines.enter().append("line")
                    .classed("bottom-line", true)
                    .attr({
                        x1: function (d) { return xScale(d) + linesGap/2; },
    
                        x2: function (d) { return xScale(d) + xScale.rangeBand() - linesGap/2; },
    
                        y1: yValue,
                        y2: yValue
                    });
                bottomLines
                    .classed("bottom-line", true)
                    .attr({
                        x1: function (d) { return xScale(d) + linesGap/2; },
    
                        x2: function (d) { return xScale(d) + xScale.rangeBand() - linesGap/2; },
    
                        y1: yValue,
                        y2: yValue
                    });
    
                bottomLines.exit().remove();
            }
        }
    });

    let chart = new newExtendedVerticalBarChart({
            "xAxisOrient": "bottom",
            "tooltip": true,
            "hasBenchmarks": true,
            "showGrayBands": false,
            "dottedBenchmarks": false,
            "defaultBenchmarkStyle": true,
            "stacked": false,
            "y1AxisOrient": "left",
            "y1AxisTicksAlign": "left",
            "legend": true,
            "y1TickSymbol": "",
            "showGrayBands": false,            
            "colors": ["#496BB3", "#F47521", "#A5A4A4", "#FEC20F"]
        }),
        dataset = {
            "xDomain": ["最大回撤", "平均滚动收益(6M)", "平均滚动收益(1Y)", "平均滚动收益(3Y)"],
            "y1AxisData": [{
                "name": tempTitle,
                "values": riskPortrait
            }],
            "Benchmarks":{
                "name": "本基金",
                "values":riskPortraitBenchMark
            }
        };

        var Utils = Core.Utils;
        minY = Math.ceil(minY / 5) * 5 - 15;
        maxY = Math.ceil(maxY / 5) * 5 + 15;
        chart.__attributes.yDomain = [minY, maxY];
        container.datum(dataset).call(chart.init());

        d3.select(id + " .mbc-axis-bottom").append("text").text("单位(%)").attr("x", "-50").attr("y", "18").attr("class", "tick_text");
        d3.select(id + " .mbc-chart-legend-inner").attr("transform", "translate(0,2)");
    }, 500);
}

export function calcAxisScale(numbers, intervals = 1, fixedScaleValue = null, scaleUnit = 0, adjustFor0 = false, lableSpace= true) {
    intervals = intervals < 1 ? 1 : intervals;
    intervals = intervals > 8 ? 8 : intervals;
    
    let max = Math.max(...numbers);
    let min = Math.min(...numbers);
    if (fixedScaleValue !== null) {
        max = Math.max(max, fixedScaleValue);
        min = Math.min(min, fixedScaleValue);
    }
    //adjust bound to set aside space for label
    if (lableSpace) {
        const labelSpace = (max - min) / 10;
        max += max > 0 ?  labelSpace : 0;
        min -= min < 0 ?  labelSpace : 0;
    }
    const diff = (max - min) / intervals;
    
    if (!scaleUnit) {
        let exponent = Math.floor(Math.log10(diff));
        scaleUnit = Math.pow(10, exponent);
    }
    
    let upperBound = Math.ceil(max / scaleUnit) * scaleUnit;
    let lowerBound = Math.floor(min / scaleUnit) * scaleUnit;
                    
    let intervalValue;
    if (fixedScaleValue === null) {
        intervalValue = Math.ceil((upperBound - lowerBound) / (intervals * scaleUnit)) * scaleUnit;
        upperBound = lowerBound + intervalValue * intervals;
        if (adjustFor0 && lowerBound > 0 && intervalValue * intervals >= max) {
            lowerBound = 0;
            upperBound = intervalValue * intervals;
        }
    } else {
        if (fixedScaleValue <= lowerBound) {
            lowerBound = fixedScaleValue;
            intervalValue = Math.ceil((upperBound - lowerBound) / (intervals * scaleUnit)) * scaleUnit;
            upperBound = lowerBound + intervalValue * intervals;
        } else if (fixedScaleValue >= upperBound) {
            upperBound = fixedScaleValue;
            intervalValue = Math.ceil((upperBound - lowerBound) / (intervals * scaleUnit)) * scaleUnit;
            lowerBound = upperBound - intervalValue * intervals;
        } else if (intervals == 1) {
            // if fixedScaleValue is between lowerBound and upperBound, and has 1 interval
            intervalValue = upperBound - lowerBound;
        } else if (intervals == 2) {
            // if fixedScaleValue is between lowerBound and upperBound, and has 2 intervals
            intervalValue = Math.max(upperBound - fixedScaleValue, fixedScaleValue - lowerBound);
            upperBound = fixedScaleValue + intervalValue;
            lowerBound = fixedScaleValue - intervalValue;
        } else {
            const intervalValueAverage = (upperBound - lowerBound) / (intervals - 1);
            let intervalth = Math.ceil((fixedScaleValue - lowerBound) / intervalValueAverage);
            let intervalValue1 = Math.ceil((fixedScaleValue - lowerBound) / (intervalth * scaleUnit)) * scaleUnit;
            let intervalValue2 = Math.ceil((upperBound - fixedScaleValue) / ((intervals - intervalth) * scaleUnit)) * scaleUnit;
            intervalValue = Math.max(intervalValue1, intervalValue2);

            upperBound = fixedScaleValue + intervalValue * (intervals - intervalth);
            lowerBound = fixedScaleValue - intervalValue * intervalth;
        }
    }
    
    return { lowerBound, upperBound, intervalValue, intervals };
}

export function riskAdjustmentChart(id, result) {
    let riskChangingRateMax = Math.max(...result.riskChangingRate);
	let riskChangingRateMin = Math.min(...result.riskChangingRate);

    let riskDecreasingRateMax = Math.max(...result.riskDecreasingRate);
    let riskDecreasingRateMin = Math.min(...result.riskDecreasingRate);

    let riskIncreasingRateMax = Math.max(...result.riskIncreasingRate);
    let riskIncreasingRateMin = Math.min(...result.riskIncreasingRate);

    let overallMax = Math.max(
        riskIncreasingRateMax,
        riskDecreasingRateMax,
        riskChangingRateMax
    );
      
    let overallMin = Math.min(
        riskIncreasingRateMin,
        riskDecreasingRateMin,
        riskChangingRateMin
    );

    let tempArray = [];
	tempArray.push(overallMax);
	tempArray.push(overallMin);
	const option = calcAxisScale(tempArray,5,0);

    let minVal;
    let maxVal;
    let interval;
    let tickValues = [];
    
    if (option) {
        minVal = option.lowerBound;
        maxVal = option.upperBound;
        interval = option.intervals;
        let ps = (maxVal-minVal)/interval;
        for (let i = 0; i < 6; i++) {
            tickValues.push(minVal);
            minVal += ps; 
        }
    }
    let LineChart = window["mbc-line"];
    let container = d3.select(id);
    // let tickValues = [0, 6, 12, 18, 24, 30];
    let chart = new LineChart({
            "xAxisOrient": "bottom",
            "tooltip": true,
            "hasBenchmarks": true,
            "showGrayBands": false,
            "dottedBenchmarks": false,
            "defaultBenchmarkStyle": false,
            "stacked": false,
            "y1AxisOrient": "left",
            "y1AxisTicksAlign": "left",
            "legend": true,
            "y1TickSymbol": "",
            //"colors": ["#496BB3", "#F47521", "#A5A4A4"],
            //"ticksNumber": 8,
            "y2": false,
            "yTickMargin": 20,
            "dottedLineNames": {
                "y1AxisData": false
            },
            "tickValues": tickValues
            //"tooltipTemplate": "<div>123</div>"
        }),
        dataset = {
            "xDomain": result.date,
            "y1AxisData": [{
                "name": "风险变动占比",
                "values": result.riskChangingRate
            }, {
                "name": "风险上升占比",
                "values": result.riskIncreasingRate
            }, {
                "name": "风险下降占比  ",
                "values": result.riskDecreasingRate
            }]
        };
    d3.select(id).style("height", "350px");
    var y = (result.maxY * 2);
    //chart.__attributes.yDomain = [0, 25];

    container.datum(dataset).call(chart.init());
    d3.select(id + " .mbc-axis-bottom").append("text").text("单位(%)").attr("x", "-50").attr("y", "18").attr("class", "tick_text");
    d3.select(id + " .mbc-chart-legend-inner").attr("transform", "translate(0,2)");

    d3.selectAll(id + " .lineDot").attr("opacity", "0");
    d3.selectAll(id + " .mbc-chart-group .line").each(function() {
        d3.select(this).attr("shape-rendering", "geometricPrecision").attr("stroke-linecap", "round").attr("stroke-linejoin", "round");
    })
}
